export default __webpack_public_path__ + "static/media/folder-add.58dcdf11.svg";